import React, { useState, useRef, Fragment, useEffect } from "react";
import clientmanagmentObj from "../../services/client-managment.service";
import DateFormat from "../../helpers/DateFormat";
import crossImgs from "../../assets/images/icons/cross.svg";
import RefreshToken from "../../helpers/RefreshToken";
import ReactDatePickerHelper from "../../helpers/ReactDatePickerHelper";
import BoLoader from "../../helpers/BoLoader";
import ModelPopup from "../../helpers/ModelPopup";

const PAGE_SIZE = 50;

const SourceType = {
  Application: 1,
  Activity: 2,
};

const fontStyle = { textTransform: "uppercase" };

const LogRecords = () => {
  const [source, setSource] = useState(SourceType.Application);
  const [keyword, setKeyword] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [page, setPage] = useState(1);
  const [searchData, setSearchData] = useState([]);
  const [searchGridSuccess, setSearchGridSuccess] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [boloader, setBoLoader] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [searchInputDisabled, setSearchInputDisabled] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);

  const scrolledRef = useRef(false);
  const searchTbl = useRef();

  useEffect(() => {
    fetchLogs(1, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [source]);

  const fetchLogs = (pageNum, append, e) => {
    if (e) e.preventDefault();
    setLoadingData(true);
    if (!append) {
      setBoLoader(true);
      setSearchGridSuccess(false);
    }

    clientmanagmentObj
      .searchLogs(
        dateFrom || null,
        dateTo || null,
        keyword || null,
        pageNum,
        PAGE_SIZE,
        source
      )
      .then((resp) => {
        setLoadingData(false);
        setBoLoader(false);
        const records = Array.isArray(resp?.data)
          ? resp.data
          : resp?.data?.result || resp?.data?.payload || [];

        setHasMore(records.length === PAGE_SIZE);

        if (append) {
          setSearchData((prev) => prev.concat(records));
        } else {
          setSearchData(records);
        }
        setSearchGridSuccess(true);
        setPage(pageNum);
        setModalShow(false);
        setSearchInputDisabled(false);
        scrolledRef.current = false;
      })
      .catch((error) => {
        setLoadingData(false);
        setBoLoader(false);
        setSearchGridSuccess(false);
        (async () => {
          let resp = await RefreshToken(
            error && error.response && error.response.status
          );
          if (resp) fetchLogs(pageNum, append);
        })();
      });
  };

  const tblScrollHandler = (e) => {
    if (!scrolledRef.current && hasMore) {
      scrolledRef.current = true;
      fetchLogs(page + 1, true);
    }
  };

  const handleInputSearchClick = (e) => {
    e.preventDefault();
    setModalShow(true);
    setSearchInputDisabled(true);
  };

  const hideSearchPopup = () => {
    setModalShow(false);
    setSearchInputDisabled(false);
  };

  const onSearchClick = (e) => {
    fetchLogs(1, false, e);
  };

  const clearSearch = () => {
    setKeyword("");
    setDateFrom("");
    setDateTo("");
    setTimeout(() => fetchLogs(1, false), 100);
  };

  const handleSourceChange = (val) => {
    setSource(val);
    setPage(1);
  };

  const dateFromHandler = (e) => {
    setDateFrom(e ? new Date(e) : "");
  };
  const dateToHandler = (e) => {
    setDateTo(e ? new Date(e) : "");
  };

  const openDetail = (log) => {
    setSelectedLog(log);
    setShowDetail(true);
  };

  const renderHeaders = () => {
    const headers =
      source === SourceType.Application
        ? [
            "TIMESTAMP",
            "METHOD",
            "ENDPOINT",
            "STATUS",
            "CORRELATION ID",
            "MESSAGE",
            "DETAILS",
          ]
        : [
            "TIMESTAMP",
            "METHOD",
            "ENDPOINT",
            "STATUS",
            "REQUEST",
            "RESPONSE",
            "DETAILS",
          ];
    return headers.map((h, i) => <th key={i}>{h}</th>);
  };

  const truncate = (val, length = 40) => {
    if (!val) return "";
    const str = typeof val === "string" ? val : String(val);
    return str.length > length ? str.substr(0, length) + "..." : str;
  };

  const renderRows = () => {
    return searchData.map((data, index) => {
      const {
        source: src,
        timestamp,
        endpoint,
        method,
        statusCode,
        requestBody,
        responseBody,
        message,
        correlationId,
      } = data;
      return (
        <tr key={index}>
          <td>
            <DateFormat date={timestamp} />
          </td>
          <td style={fontStyle} title={method}>
            {method}
          </td>
          <td title={endpoint}>{truncate(endpoint, 40)}</td>
          <td style={fontStyle} title={statusCode}>
            {statusCode}
          </td>
          {source === SourceType.Application ? (
            <Fragment>
              <td title={correlationId}>{truncate(correlationId, 50)}</td>
              <td title={message}>{truncate(message, 40)}</td>
            </Fragment>
          ) : (
            <Fragment>
              <td title={requestBody}>{truncate(requestBody, 30)}</td>
              <td title={responseBody}>{truncate(responseBody, 30)}</td>
            </Fragment>
          )}
          <td>
            <span
              className="icon-show"
              style={{ cursor: "pointer" }}
              onClick={() => openDetail(data)}
            ></span>
          </td>
        </tr>
      );
    });
  };

  return (
    <div className="col-xl-9 col-lg-12 bo-main-content">
      <BoLoader loading={boloader} />
      <h3>Log Records</h3>

      <div className="row mt-20">
        <div className="col-xl-12">
          <ul className="nav nav-tabs mb-20" role="tablist">
            <li className="nav-item">
              <button
                type="button"
                className={
                  "nav-link " +
                  (source === SourceType.Application ? "active" : "")
                }
                onClick={() => handleSourceChange(SourceType.Application)}
              >
                Application Logs
              </button>
            </li>
            <li className="nav-item">
              <button
                type="button"
                className={
                  "nav-link " +
                  (source === SourceType.Activity ? "active" : "")
                }
                onClick={() => handleSourceChange(SourceType.Activity)}
              >
                Activity Logs
              </button>
            </li>
          </ul>
        </div>
      </div>

      <Fragment>
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="row row-search">
            <div className="col-xl-12 col-12">
              <div className="form-group">
                <div className="form-controls">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search logs"
                    onClick={handleInputSearchClick}
                    disabled={searchInputDisabled}
                  />
                  <span className="icon-search _ico"></span>

                  <div
                    className="bo-cardsearch"
                    style={{ display: modalShow ? "" : "none" }}
                  >
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="col-md-4">
                          <img
                            className="cross-icon cross-modal"
                            src={crossImgs}
                            aria-label="Close"
                            onClick={hideSearchPopup}
                            alt=""
                          />
                        </div>
                        <div className="col-md-12 form-group form-search mr-20">
                          <label>Keyword</label>
                          <div className="form-controls mr-20">
                            <input
                              type="text"
                              value={keyword}
                              onChange={(e) => setKeyword(e.target.value)}
                              className="form-control"
                              maxLength={100}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group form-search mr-20">
                          <label>Date From</label>
                          <div className="form-controls">
                            <ReactDatePickerHelper
                              datevalue={dateFrom}
                              onchangedate={dateFromHandler}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group form-search mr-20">
                          <label>Date To</label>
                          <div className="form-controls">
                            <ReactDatePickerHelper
                              datevalue={dateTo}
                              onchangedate={dateToHandler}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group form-search mr-20">
                          <label>Source</label>
                          <div className="form-controls">
                            <select
                              className="form-control"
                              value={source}
                              onChange={(e) =>
                                handleSourceChange(Number(e.target.value))
                              }
                            >
                              <option value={SourceType.Application}>
                                Application
                              </option>
                              <option value={SourceType.Activity}>
                                Activity
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group submit-field form-search">
                          <button
                            id="searchBtnLogs"
                            className="btn btn-large mr-19"
                            onClick={onSearchClick}
                          >
                            Search
                          </button>
                          <button
                            className="btn btn-outline"
                            onClick={clearSearch}
                          >
                            Clear Search
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <span className="help-block d-none"></span>
              </div>
            </div>
          </div>
        </form>
      </Fragment>

      {searchGridSuccess && (
        <div className="table-wrap" ref={searchTbl}>
          <table
            className="table table-borderless bo-table table-cards"
            onScroll={tblScrollHandler}
            onWheel={tblScrollHandler}
          >
            <thead>
              <tr>{renderHeaders()}</tr>
            </thead>
            <tbody>{renderRows()}</tbody>
          </table>
        </div>
      )}

      {loadingData ? (
        <div className="loading-more">
          <div className="loader">
            <div></div>
          </div>
          <p>loading data</p>
        </div>
      ) : searchGridSuccess && searchData.length === 0 ? (
        <div className="d-flex align-content-center justify-content-center no-clients-msg">
          <div className="text-center">
            <span className="icon-clients-empty">
              <span className="path1"></span>
              <span className="path2"></span>
              <span className="path3"></span>
              <span className="path4"></span>
              <span className="path5"></span>
              <span className="path6"></span>
            </span>
            <h3>Empty Log Listing</h3>
            <h6>There are no log(s) available for now.</h6>
          </div>
        </div>
      ) : (
        ""
      )}

      <ModelPopup
        show={showDetail}
        onHide={() => setShowDetail(false)}
        modelheading={""}
        showheader={"false"}
        className="smallPopup issueCardSmall"
        dialogClassName="modal-dialog modal-dialog-centered mwidth-52"
        backdrop="static"
        keyboard={false}
        modelbody={[
          <Fragment>
            <div className="row">
              <div className="col-md-12">
                <h2>Log Details</h2>
                <div className="mt-16">
                  {selectedLog && (
                    <div>
                      <p>
                        <b>Source:</b> {selectedLog.source}
                      </p>
                      <p>
                        <b>Timestamp:</b>{" "}
                        <DateFormat date={selectedLog.timestamp} />
                      </p>
                      <p>
                        <b>Method:</b> {selectedLog.method}
                      </p>
                      <p>
                        <b>Endpoint:</b> {selectedLog.endpoint}
                      </p>
                      <p>
                        <b>Status:</b> {selectedLog.statusCode}
                      </p>
                      {selectedLog.correlationId && (
                        <p>
                          <b>Correlation Id:</b> {selectedLog.correlationId}
                        </p>
                      )}
                      {selectedLog.message && (
                        <p>
                          <b>Message:</b> {selectedLog.message}
                        </p>
                      )}
                      <p>
                        <b>Request Body:</b>
                      </p>
                      <pre
                        style={{
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-all",
                          maxHeight: 200,
                          overflow: "auto",
                          background: "#f7f7f7",
                          padding: 8,
                        }}
                      >
                        {selectedLog.requestBody || "-"}
                      </pre>
                      <p>
                        <b>Response Body:</b>
                      </p>
                      <pre
                        style={{
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-all",
                          maxHeight: 200,
                          overflow: "auto",
                          background: "#f7f7f7",
                          padding: 8,
                        }}
                      >
                        {selectedLog.responseBody || "-"}
                      </pre>
                    </div>
                  )}
                  <div className="form-group submit-field d-flex justify-content-between mt-20 mb-0">
                    <button
                      className="btn btn-large"
                      onClick={() => setShowDetail(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>,
        ]}
      />
    </div>
  );
};

export default LogRecords;
